import React, {Component} from 'react';
import {Link} from 'react-router-dom';
//import logo from '../assets/logo.svg';
import logoBlack from '../assets/logo-2.webp';
import logoWhite from '../assets/logo-3.webp';
import {COLORS} from '../constants';

class Logo extends Component {

  static defaultProps = {
    link: '/home',
    isLink: true,
    showText: true,
    useWhite: false,
  }

  render() {
    const {
      link,
      isLink,
      showText,
      useWhite,
    } = this.props;

    const logo = useWhite
      ? logoWhite
      : logoBlack
    

    if (isLink) {
      return(
        <Link to={link}>
        <div 
          style={s.container}
          className="logo hover-pointer"
        >
          <div style={s.logoContainer}>
            <img
              src={logo}
              style={s.logo}
              alt="logo"
            />
          </div>

          {showText && <div style={s.labelContainer}>
            <div style={s.label}>
              HISTORIA
            </div>
          </div>}
        </div>
        </Link>
      )
    }

    else {
      return(
        <div 
          style={s.container}
          className='logo'
        >
          <div style={s.logoContainer}>
            <img
              src={logo}
              style={s.logo}
              alt="logo"
            />
          </div>

          {showText &&<div style={s.labelContainer}>
            <div style={s.label}>
              HISTORIA
            </div>
          </div>}
        </div>
      )
    }
  }
}


const s = {
  container: {
    display: 'flex',
    alignItems: 'center',
    userSelect: 'none',
  },
  logoContainer: {
  },
  logo: {
    //width: '100%',
    height: '50px',
    animation: 'App-logo-spin infinite 20s linear',
    fill: COLORS.white,
    background: 'black',
  },
  labelContainer: {
    marginLeft: '10px',
  },
  label: {
    userSelect: 'none',
    letterSpacing: '1px',
    fontWeight: 'bold',
    color: COLORS.white,
  },
}

export default Logo;



// WEBPACK FOOTER //
// ./src/main/Logo.js